// extracted by mini-css-extract-plugin
export var avatarContainer = "_3v-1";
export var largeAvatarContainer = "_3v-2";
export var smallAvatarContainer = "_3v-0";